/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timeOfDay: NonNullable<unknown>, subSport: NonNullable<unknown>, sport: NonNullable<unknown> }} Ui_Session_Name_SubInputs */

const en_ui_session_name_sub = /** @type {(inputs: Ui_Session_Name_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.timeOfDay} ${i?.subSport} ${i?.sport}`)
};

const de_ui_session_name_sub = /** @type {(inputs: Ui_Session_Name_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.subSport}-${i?.sport} ${i?.timeOfDay}`)
};

/**
* | output |
* | --- |
* | "{timeOfDay} {subSport} {sport}" |
*
* @param {Ui_Session_Name_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_name_sub = /** @type {((inputs: Ui_Session_Name_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_Name_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_name_sub(inputs)
	return de_ui_session_name_sub(inputs)
});